import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LinkAction } from '@textbook-api-client';
import { TextbookActionBase } from '../@base/textbook-action-base.model';
import {
  TextbookActionsHandler,
  TextbookActionsHandlerToken,
} from '../../../external/providers/textbook-actions-handler';
import { GroupInfo } from '../../models';

@Component({
  selector: 'txtb-link',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LinkComponent extends TextbookActionBase<LinkAction> implements OnInit {
  @Input() groupInfo!: GroupInfo;

  constructor(
    @Inject(TextbookActionsHandlerToken) private textbookActionsHandler: TextbookActionsHandler,
    private activatedRoute: ActivatedRoute
  ) {
    super();
  }

  ngOnInit(): void {
    this.textbookActionsHandler
      .backToTextbook(this.activatedRoute)
      .then(() => this.textbookActionsHandler.redirectToExternalUrl(this.action.meta.url));
  }
}
